import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { withFormikField } from 'utils/formik';
import { Field, Flexer } from '@ontruck/orc';
import { injectIntl } from 'react-intl';
const StyledField = styled(Field)`
  //   width: 100%;
`;

const TenantReferenceSection = ({ field, form, values = {}, intl, ...props }) => {
  const t = intl.messages.modules.shipper_order.form.reference_section;
  const {
    booking_number = '',
    logistics_operator_code = '',
    release_container_provider_reference = '',
    acceptance_container_provider_reference = '',
  } = values;
  const { setFieldValue } = form;

  /**
   * Expediente OL   (logistics_operator_code)
      Ref. Emisor entrega  (release_container_provider_reference)
      Ref. Emisor admisión (acceptance_container_provider_reference)  
   */

  return (
    <Flexer.Parent justifyContent="space-between" mBottom="M">
      <Flexer.Child>
        <StyledField
          {...props}
          label={t.booking_number}
          value={booking_number}
          error={false}
          onChange={(e, { value }) => {
            setFieldValue(`booking_number`, value);
          }}
        />
      </Flexer.Child>
      <Flexer.Child>
        <StyledField
          {...props}
          label={t.logistics_operator_code}
          value={logistics_operator_code}
          error={false}
          onChange={(e, { value }) => {
            setFieldValue(`logistics_operator_code`, value);
          }}
        />
      </Flexer.Child>
      <Flexer.Child>
        <StyledField
          {...props}
          label={t.release_container_provider_reference}
          value={release_container_provider_reference}
          error={false}
          onChange={(e, { value }) => {
            setFieldValue(`release_container_provider_reference`, value);
          }}
        />
      </Flexer.Child>
      <Flexer.Child>
        <StyledField
          {...props}
          label={t.acceptance_container_provider_reference}
          value={acceptance_container_provider_reference}
          error={false}
          onChange={(e, { value }) => {
            setFieldValue(`acceptance_container_provider_reference`, value);
          }}
        />
      </Flexer.Child>
    </Flexer.Parent>
  );
};

TenantReferenceSection.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

export default withFormikField(injectIntl(TenantReferenceSection));
